import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';

const hasAccessToRoute = action => {
    // eslint-disable-next-line no-underscore-dangle
    const actions = window.DashboardComponent._userSession._userEntity.authorizedActions;
    return actions.includes(action);
};

const ProtectedRoute = ({ action, renderer, redirectRoute, ...rest }) => {
    return (
        <Route
            {...rest}
            /* eslint-disable-next-line react/jsx-no-bind */
            render={props => (
                hasAccessToRoute(action)
                    ? renderer(props)
                    : <Redirect to={redirectRoute} />
            )}
        />
    );
};

ProtectedRoute.propTypes = {
    action: PropTypes.string.isRequired,
    renderer: PropTypes.func.isRequired
};

export default ProtectedRoute;
